import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-network',
  templateUrl: './network.component.svg',
})
export class NetworkComponent extends MedrecordIcon {
  viewHeight = 24;
  viewWidth = 24;
}
